import { T2, TEXT_LENGTH } from '@nile/components';
import { Avatar } from '@superops/ui-design-system';
import { cloneDeep, includes } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';

const Input = styled.input`
  height: 30px;
  border: none;
  outline: none;
  margin: 0;
  background-color: transparent;
  ${(props) => props.fontSize && `font-size: ${props.fontSize}`}
`;
const InlineMultiTextFieldContainer = styled.div`
  flex-wrap: wrap;
  // border-bottom: 1px solid #ececec;
  max-width: 100%;
  overflow-x: hidden;
  .Superops-Avatar {
    width: 22px;
    min-width: 22px;
  }
  ${(props) => props.showBorder && `border-bottom: 1px solid #d4d4d4;`}
`;

function InlineMultiTextField(props) {
  const {
    placeholder,
    label,
    name,
    deleteButton,
    onItemAdded,
    onItemDeleted,
    className,
    labelClassName,
    charCodes,
    values: inputValues,
    shouldAddOnBlur,
    addHelper,
    handleValidation,
    readOnly,
    itemBackground,
    showAvatar,
    fontSize
  } = props;
  const [values, setValues] = useState(inputValues || []);
  const [value, setValue] = useState('');

  const handleItemAdd = (val) => {
    const email = val.trim();
    if (
      includes(values, email) ||
      !email ||
      (handleValidation && !handleValidation(email))
    ) {
      setValue(email);
      return;
    }
    const newValues = values.concat(value);
    setValues(newValues);
    setValue('');
    onItemAdded(value, newValues);
  };

  const handleItemRemove = (value) => {
    const newValues = values.filter((v) => v !== value);
    onItemDeleted(value, newValues);
    setValues(newValues);
  };

  const handleItemDelete = () => {
    if (values.length) {
      handleItemRemove(values[values.length - 1]);
    }
  };

  const handleBlur = (e) => {
    // 13: Enter
    if (shouldAddOnBlur) {
      e.preventDefault();
      handleItemAdd(e.target.value);
    }
  };

  const handleValueChange = (e) => {
    setValue(e.target.value.trim());
  };

  const handleKeypress = (e) => {
    if (includes(charCodes, e.keyCode)) {
      e.preventDefault();
      handleItemAdd(e.target.value);
    }
    if (e.key === 'Backspace' && !value.length) {
      e.preventDefault();
      handleItemDelete(e.target.value);
    }
  };

  return (
    <InlineMultiTextFieldContainer
      className="multiple-value-text-input fx actr full-width"
      showBorder={props.showBorder}
    >
      {values.length > 0
        ? values.map((el) => {
            return (
              <Item fontSize={fontSize} background={itemBackground}>
                {showAvatar && (
                  <Avatar name={el} initials={el[0]} size="small" />
                )}
                <div className="ml-5">{el}</div>
                <Delete
                  className="multi-text-delete"
                  tabIndex="-1"
                  role="button"
                  onKeyPress={() => handleItemRemove(el)}
                  onClick={() => handleItemRemove(el)}
                >
                  {deleteButton}
                </Delete>
              </Item>
            );
          })
        : ''}
      <Input
        name={name}
        placeholder={
          values.length ? null : placeholder || 'Type value and press enter'
        }
        value={value}
        type="text"
        // onKeyPress={handleKeypress}
        fontSize={fontSize}
        onKeyDown={handleKeypress}
        onChange={handleValueChange}
        onBlur={handleBlur}
        className={`fg1 ${className}`}
        maxLength={TEXT_LENGTH.size_4}
        readOnly={readOnly}
      />
    </InlineMultiTextFieldContainer>
  );
}

const Item = styled.div`
  height: 24px;
  display: flex;
  font-size: ${(props) => props.fontSize || '14px'};
  font-weight: 500;
  margin-right: 8px;
  line-height: 20px;
  margin-bottom: 2px;
  align-items: center;
  background: ${(props) => props.background || '#ececec'};
  border-radius: 12px;
  padding: 2px 8px 2px 1px;
`;

const Delete = styled.div`
  margin-left: 4px;
  cursor: pointer;
  outline: none;
`;

InlineMultiTextField.defaultProps = {
  placeholder: '',
  charCodes: [13],
  deleteButton: <span>&times;</span>,
  values: [],
  label: '',
  shouldAddOnBlur: true,
  className: '',
  labelClassName: ''
};

export default InlineMultiTextField;
